const STATUS_COPY = {
  review_in_progress: {
    label: { en: 'Application received', fr: 'Demande reçue' },
    cardHeading: { en: 'Application received', fr: 'Demande reçue' },
    dashboardLead: { en: 'Your application has been received.', fr: 'Votre demande a été reçue.' },
    dashboardBody: {
      en: 'Use this dashboard to check its status and read messages from the program team.',
      fr: 'Utilisez ce tableau de bord pour vérifier son état et lire les messages de l’équipe du programme.',
    },
    summary: {
      en: 'We have received your application and it is under review.',
      fr: 'Nous avons reçu votre demande et elle est en cours d’examen.',
    },
    nextSteps: {
      en: 'No action is needed right now. We will contact you here if we need documents or more information.',
      fr: 'Aucune action n’est requise pour le moment. Nous communiquerons avec vous ici si nous avons besoin de documents ou de renseignements supplémentaires.',
    },
    bannerModifier: 'submitted',
  },
  action_required: {
    label: { en: 'Action required', fr: 'Action requise' },
    cardHeading: { en: 'Action required', fr: 'Action requise' },
    dashboardLead: { en: 'There is an update on your application.', fr: 'Il y a une mise à jour concernant votre demande.' },
    dashboardBody: {
      en: 'Review your messages for next steps or any information we still need from you.',
      fr: 'Consultez vos messages pour connaître les prochaines étapes ou les renseignements qu’il nous manque.',
    },
    summary: {
      en: 'There is an update on your application.',
      fr: 'Il y a une mise à jour concernant votre demande.',
    },
    nextSteps: {
      en: 'Check your messages for the next steps or any information we still need from you.',
      fr: 'Consultez vos messages pour connaître les prochaines étapes ou les renseignements qu’il nous manque.',
    },
    actionLabel: { en: 'View messages', fr: 'Voir les messages' },
    actionHref: '/messages',
    bannerModifier: 'docs-requested',
  },
  support_active: {
    label: { en: 'Current PATH support', fr: 'Soutien PATH en cours' },
    cardHeading: { en: 'Current PATH support', fr: 'Soutien PATH en cours' },
    dashboardLead: { en: 'Your current PATH support information is available here.', fr: 'Les renseignements sur votre soutien PATH en cours sont disponibles ici.' },
    dashboardBody: {
      en: 'Check this dashboard for plan activities, documents, and messages from the program team.',
      fr: 'Consultez ce tableau de bord pour vos activités de plan, vos documents et les messages de l’équipe du programme.',
    },
    summary: {
      en: 'Your current PATH support information is available here.',
      fr: 'Les renseignements sur votre soutien PATH en cours sont disponibles ici.',
    },
    nextSteps: {
      en: 'Review your current plan activities and check your messages for any next steps.',
      fr: 'Consultez vos activités de plan en cours et vérifiez vos messages pour connaître les prochaines étapes.',
    },
    bannerModifier: 'support',
    emptyActivitiesMessage: {
      en: 'New activities, documents, and messages will appear here when they are ready.',
      fr: 'Les nouvelles activités, les documents et les messages apparaîtront ici lorsqu’ils seront prêts.',
    },
  },
  approved: {
    label: { en: 'Current PATH support', fr: 'Soutien PATH en cours' },
    cardHeading: { en: 'Current PATH support', fr: 'Soutien PATH en cours' },
    dashboardLead: { en: 'Your PATH support information is available here.', fr: 'Les renseignements sur votre soutien PATH sont disponibles ici.' },
    dashboardBody: {
      en: 'Check this dashboard for plan activities, documents, and messages from the program team.',
      fr: 'Consultez ce tableau de bord pour vos activités de plan, vos documents et les messages de l’équipe du programme.',
    },
    summary: {
      en: 'Your current PATH support information is available here.',
      fr: 'Les renseignements sur votre soutien PATH en cours sont disponibles ici.',
    },
    nextSteps: {
      en: 'New activities, documents, and messages will appear here when they are ready.',
      fr: 'Les nouvelles activités, les documents et les messages apparaîtront ici lorsqu’ils seront prêts.',
    },
    bannerModifier: 'approved',
    emptyActivitiesMessage: {
      en: 'New activities, documents, and messages will appear here when they are ready.',
      fr: 'Les nouvelles activités, les documents et les messages apparaîtront ici lorsqu’ils seront prêts.',
    },
  },
  not_approved: {
    label: { en: 'Application update available', fr: 'Mise à jour disponible' },
    cardHeading: { en: 'Application update', fr: 'Mise à jour de la demande' },
    dashboardLead: { en: 'NWAC has an update about your application.', fr: 'L’AFAC a une mise à jour concernant votre demande.' },
    dashboardBody: {
      en: 'Please read your messages or contact the program team for details.',
      fr: 'Veuillez lire vos messages ou communiquer avec l’équipe du programme pour obtenir les détails.',
    },
    summary: {
      en: 'NWAC has an update about your application.',
      fr: 'L’AFAC a une mise à jour concernant votre demande.',
    },
    nextSteps: {
      en: 'Please read your messages or contact the program team for details.',
      fr: 'Veuillez lire vos messages ou communiquer avec l’équipe du programme pour obtenir les détails.',
    },
    bannerModifier: 'rejected',
  },
  application_update: {
    label: { en: 'Application update available', fr: 'Mise à jour disponible' },
    cardHeading: { en: 'Application update', fr: 'Mise à jour de la demande' },
    dashboardLead: { en: 'NWAC has an update about your application.', fr: 'L’AFAC a une mise à jour concernant votre demande.' },
    dashboardBody: {
      en: 'Please read your messages or contact the program team for details.',
      fr: 'Veuillez lire vos messages ou communiquer avec l’équipe du programme pour obtenir les détails.',
    },
    summary: {
      en: 'NWAC has an update about your application.',
      fr: 'L’AFAC a une mise à jour concernant votre demande.',
    },
    nextSteps: {
      en: 'Please read your messages or contact the program team for details.',
      fr: 'Veuillez lire vos messages ou communiquer avec l’équipe du programme pour obtenir les détails.',
    },
    actionLabel: { en: 'View messages', fr: 'Voir les messages' },
    actionHref: '/messages',
    bannerModifier: 'update',
  },
  closed: {
    label: { en: 'Application history', fr: 'Historique de la demande' },
    cardHeading: { en: 'Application history', fr: 'Historique de la demande' },
    dashboardLead: { en: 'This application is now in your history.', fr: 'Cette demande fait maintenant partie de votre historique.' },
    dashboardBody: {
      en: 'You can still review the application details and messages here.',
      fr: 'Vous pouvez toujours consulter ici les détails de la demande et les messages.',
    },
    summary: {
      en: 'This application is now in your history.',
      fr: 'Cette demande fait maintenant partie de votre historique.',
    },
    nextSteps: {
      en: 'You can still review the application details and messages here.',
      fr: 'Vous pouvez tout de même consulter ici les détails de la demande et les messages.',
    },
    bannerModifier: 'completed',
  },
  application_history: {
    label: { en: 'Application history', fr: 'Historique de la demande' },
    cardHeading: { en: 'Application history', fr: 'Historique de la demande' },
    dashboardLead: { en: 'You can review your previous PATH application and activities here.', fr: 'Vous pouvez consulter ici votre demande PATH précédente et vos activités.' },
    dashboardBody: {
      en: 'You can start a new application if you need more PATH support.',
      fr: 'Vous pouvez commencer une nouvelle demande si vous avez besoin d’un autre soutien PATH.',
    },
    summary: {
      en: 'This application is now in your history.',
      fr: 'Cette demande fait maintenant partie de votre historique.',
    },
    nextSteps: {
      en: 'You can still review the application details and messages here.',
      fr: 'Vous pouvez toujours consulter ici les détails de la demande et les messages.',
    },
    bannerModifier: 'history',
  },
};

const translate = (copy, language) => {
  if (!copy) return '';
  return language === 'fr' ? copy.fr : copy.en;
};

export const normalizeParticipantStatus = (status) => {
  if (!status) return null;
  const token = String(status).trim().toLowerCase();
  if (!token) return null;
  return token.replace(/\s+/g, '_');
};

export function getParticipantStatusPresentation(status, language, { hasPlanActivities = false } = {}) {
  const key = normalizeParticipantStatus(status) || 'review_in_progress';
  const base = STATUS_COPY[key] || STATUS_COPY.review_in_progress;
  const isSupportStatus = key === 'support_active' || key === 'approved';
  const supportBody = hasPlanActivities
    ? {
        en: 'Review your current plan activities, documents, and messages below.',
        fr: 'Consultez ci-dessous vos activités de plan, vos documents et vos messages.',
      }
    : null;
  const supportNextSteps = hasPlanActivities
    ? {
        en: 'Review your current plan activities and check your messages for any next steps.',
        fr: 'Consultez vos activités de plan en cours et vérifiez vos messages pour connaître les prochaines étapes.',
      }
    : null;

  return {
    key,
    label: translate(base.label, language),
    cardHeading: translate(base.cardHeading, language),
    dashboardLead: translate(base.dashboardLead, language),
    dashboardBody: translate(isSupportStatus && supportBody ? supportBody : base.dashboardBody, language),
    summary: translate(base.summary, language),
    nextSteps: translate(isSupportStatus && supportNextSteps ? supportNextSteps : base.nextSteps, language),
    actionLabel: translate(base.actionLabel, language),
    actionHref: base.actionHref || null,
    bannerModifier: base.bannerModifier || '',
    emptyActivitiesMessage: translate(base.emptyActivitiesMessage, language),
  };
}

export function getParticipantStatusBannerClass(status) {
  const key = normalizeParticipantStatus(status) || 'review_in_progress';
  const modifier = STATUS_COPY[key]?.bannerModifier || '';
  return modifier ? `govuk-notification-banner govuk-notification-banner--${modifier} app-dashboard-card` : 'govuk-notification-banner app-dashboard-card';
}
